import { AfterContentInit, Directive, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormField, MatCheckbox } from '@angular/material';
import { BillComponent } from './bill.component';
@Directive({
	selector: '[formControlName][commonBillField]'
})
export class BillFieldDirective implements AfterContentInit {
	constructor(
		private control: NgControl,
		private bill: BillComponent,
		@Optional() private matField: MatFormField,
		@Optional() private matCheckBox: MatCheckbox
	) {}
	ngAfterContentInit(): void {
		if (this.bill.fieldMap[this.control.name].Hidden) {
			if (this.matField) {
				this.matField._elementRef.nativeElement.style.display = 'none';
			} else if (this.matCheckBox) {
				this.matCheckBox._elementRef.nativeElement.style.display = 'none';
			}
		}
	}
}
